import React from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import { IEhs } from '@relab/alstom-ptw-shared';
import { Message } from 'semantic-ui-react';
import { FileDownloadLink } from '../../../FileDownloadLink';

export const EhsPhaseClosureAttachment = () => {
  const { values, setFieldValue } = useFormikContext<IEhs>();

  return (
    <>
      {values.ehsClosureFile ? (
        values.ehsClosureFile._id ? (
          <FileDownloadLink path={`/ehs/${values._id}/file/attachments/${values.ehsClosureFile._id}`}>
            {values.ehsClosureFile.name}
          </FileDownloadLink>
        ) : (
          <div style={{ margin: '10px' }}>{values.ehsClosureFile.name}</div>
        )
      ) : (
        <>
          <input
            type="file"
            name="ehsClosureFile"
            onChange={(e) => {
              setFieldValue('ehsClosureFile', e.target.files[0]);
            }}
          />

          <ErrorMessage name="ehsClosureFile">
            {(msg) => <Message error visible content={msg} style={{ margin: '0 15px' }} />}
          </ErrorMessage>
        </>
      )}
    </>
  );
};
